const base64js = require('base64-js')

// Web push is optional, but nothing in this file used to behave that way.
//
// This module is imported by packs/application.js, and webpack hoists ES imports
// above every require() in the same module -- so this runs BEFORE @rails/ujs,
// turbolinks, bootstrap, select2 and `global.$ = jQuery`. Anything thrown at module
// scope here takes the entire bundle down with it, leaving the app with no jQuery
// and every Bootstrap modal dead. Two things used to throw:
//
//   1. VAPID_PUBLIC_KEY is substituted at BUILD time by the EnvironmentPlugin in
//      config/webpack/environment.js, from a process.env that dotenv populates from
//      .env. The Docker build has no .env (.dockerignore excludes it on purpose), so
//      the key compiled to `undefined` and base64js.toByteArray(undefined) threw.
//   2. navigator.serviceWorker is undefined outside a secure context, so the
//      unguarded `navigator.serviceWorker.ready` threw over plain HTTP.
//
// Both are now non-fatal: push notifications switch off and the rest of the app
// keeps working.
function decodeVapidKey(encodedKey) {
    if (!encodedKey) {
        console.warn('[Companion]', 'VAPID_PUBLIC_KEY was not set when the bundle was built; push notifications are disabled.')
        return null
    }

    try {
        return new Uint8Array(base64js.toByteArray(encodedKey))
    } catch (error) {
        console.error('[Companion]', 'VAPID_PUBLIC_KEY is not valid base64; push notifications are disabled.', error)
        return null
    }
}

const vapidPublicKey = decodeVapidKey(process.env.VAPID_PUBLIC_KEY)

function subscribeToPush(registration) {
    return registration.pushManager
        .subscribe({
            userVisibleOnly: true,
            applicationServerKey: vapidPublicKey
        })
}

if (!navigator.serviceWorker) {
    console.error('Service worker is not supported in this browser');
} else {
    navigator.serviceWorker.register('/serviceworker.js', { scope: './' })
        .then(function(reg) {
            console.log('[Companion]', 'Service worker registered!', reg);
        });

    if (vapidPublicKey) {
        navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
            subscribeToPush(serviceWorkerRegistration).then((subscription) => {
                $.post("/subscribe", { subscription: subscription.toJSON() })
            });
        });

        // Let's check if the browser supports notifications
        if (!("Notification" in window)) {
            console.error("This browser does not support desktop notification");
        }

        // Let's check whether notification permissions have already been granted
        else if (Notification.permission === "granted") {
            console.log("Permission to receive notifications has been granted");
        }

        // Otherwise, we need to ask the user for permission
        else if (Notification.permission !== 'denied') {
            Notification.requestPermission(function(permission) {
                if (permission === "granted") {
                    console.log("Permission to receive notifications has been granted");
                    getKeys();
                }
            });
        }
    }
}

function getKeys() {
    navigator.serviceWorker.register('/serviceworker.js', { scope: './' })
        .then((registration) => {
            subscribeToPush(registration).then((subscription) => {
                console.log('subscribe and test push notification')
                $.post("/subscribe", { subscription: subscription.toJSON() })
                    .then(() => $.post("/test"));
            });
        })
}
